import { ApiMethodExecutingError } from '../service/Errors';
import { TurbolandingPage } from '../typings/banners';
import { EditedBannerTurbolanding } from '../typings/bannersEditState';
import { EditorPlaceId, TurboCreationMode, TurboTemplate } from '../typings/common';

export const UPDATE_TURBOLANDINGS = 'UPDATE_TURBOLANDINGS';
export type UPDATE_TURBOLANDINGS = typeof UPDATE_TURBOLANDINGS;

export const UPDATE_TURBOLANDINGS_DATA = 'UPDATE_TURBOLANDINGS_DATA';
export type UPDATE_TURBOLANDINGS_DATA = typeof UPDATE_TURBOLANDINGS_DATA;

export const OPEN_TURBOLANDINGS_CONSTRUCTOR = 'OPEN_TURBOLANDINGS_CONSTRUCTOR';
export type OPEN_TURBOLANDINGS_CONSTRUCTOR = typeof OPEN_TURBOLANDINGS_CONSTRUCTOR;

export const CLOSE_TURBOLANDINGS_CONSTRUCTOR = 'CLOSE_TURBOLANDINGS_CONSTRUCTOR';
export type CLOSE_TURBOLANDINGS_CONSTRUCTOR = typeof CLOSE_TURBOLANDINGS_CONSTRUCTOR;

export const GET_TURBOLANDING_INFO = 'GET_TURBOLANDING_INFO';
export type GET_TURBOLANDING_INFO = typeof GET_TURBOLANDING_INFO;

export const SHOW_TURBOLANDING_INFO_ERROR = 'SHOW_TURBOLANDING_INFO_ERROR';
export type SHOW_TURBOLANDING_INFO_ERROR = typeof SHOW_TURBOLANDING_INFO_ERROR;

export const UPDATE_TURBOLANDING = 'UPDATE_TURBOLANDING';
export type UPDATE_TURBOLANDING = typeof UPDATE_TURBOLANDING;

export interface UpdateTurbolandings {
    type: UPDATE_TURBOLANDINGS;
    data: Record<EditorPlaceId, EditedBannerTurbolanding>;
}

export function updateTurbolandings(data: Record<EditorPlaceId, EditedBannerTurbolanding>): UpdateTurbolandings {
    return {
        type: UPDATE_TURBOLANDINGS,
        data
    };
}

export interface UpdateTurbolandingsData {
    type: UPDATE_TURBOLANDINGS_DATA;
    data: Record<EditorPlaceId, EditedBannerTurbolanding>;
}

export function updateTurbolandingsData(
    data: Record<EditorPlaceId, EditedBannerTurbolanding>
): UpdateTurbolandingsData {
    return {
        type: UPDATE_TURBOLANDINGS_DATA,
        data
    };
}

export interface OpenTurbolandingsConstructorPayload {
    templateId?: TurboTemplate;
    creationMode?: TurboCreationMode;
    enableTemplates?: string[];
    disableTemplates?: string[];
}

export interface OpenTurbolandingsConstructor {
    type: OPEN_TURBOLANDINGS_CONSTRUCTOR;
    id: EditorPlaceId;
    payload?: OpenTurbolandingsConstructorPayload;
}
export function openTurbolandingsConstructor(
    id: EditorPlaceId,
    payload?: OpenTurbolandingsConstructorPayload
): OpenTurbolandingsConstructor {
    return {
        type: OPEN_TURBOLANDINGS_CONSTRUCTOR,
        id,
        payload
    };
}

export const OPEN_EDIT_TURBOLANDINGS_CONSTRUCTOR_METRIKA = 'OPEN_EDIT_TURBOLANDINGS_CONSTRUCTOR_METRIKA';
export type OPEN_EDIT_TURBOLANDINGS_CONSTRUCTOR_METRIKA = typeof OPEN_EDIT_TURBOLANDINGS_CONSTRUCTOR_METRIKA;

export interface OpenEditTurbolandingsConstructorMetrikaAction {
    type: OPEN_EDIT_TURBOLANDINGS_CONSTRUCTOR_METRIKA;
}

export function openEditTurbolandingsConstructorMetrika(): OpenEditTurbolandingsConstructorMetrikaAction {
    return {
        type: OPEN_EDIT_TURBOLANDINGS_CONSTRUCTOR_METRIKA
    };
}

export interface CloseTurbolandingsConstructor {
    type: CLOSE_TURBOLANDINGS_CONSTRUCTOR;
    id: EditorPlaceId;
}
export function closeTurbolandingsConstructor(id: EditorPlaceId): CloseTurbolandingsConstructor {
    return {
        type: CLOSE_TURBOLANDINGS_CONSTRUCTOR,
        id
    };
}

export interface GetTurbolandingInfo {
    type: GET_TURBOLANDING_INFO;
    id: EditorPlaceId;
    landingId: number;
}
export function getTurbolandingInfo(id: EditorPlaceId, landingId: number): GetTurbolandingInfo {
    return {
        type: GET_TURBOLANDING_INFO,
        id,
        landingId
    };
}

export interface UpdateTurbolanding {
    type: UPDATE_TURBOLANDING;
    id: EditorPlaceId;
    page: TurbolandingPage;
}
export function updateTurbolanding(data: { id: EditorPlaceId; page: TurbolandingPage }): UpdateTurbolanding {
    return {
        type: UPDATE_TURBOLANDING,
        ...data
    };
}

export interface ShowTurbolandingInfoError {
    type: SHOW_TURBOLANDING_INFO_ERROR;
    id: EditorPlaceId;
}
export function showTurbolandingInfoError(
    id: EditorPlaceId,
    error: ApiMethodExecutingError | string
): ShowTurbolandingInfoError {
    return {
        type: SHOW_TURBOLANDING_INFO_ERROR,
        id
    };
}

export type TurbolandingsActions =
    | UpdateTurbolandings
    | UpdateTurbolandingsData
    | OpenTurbolandingsConstructor
    | CloseTurbolandingsConstructor
    | GetTurbolandingInfo
    | ShowTurbolandingInfoError
    | UpdateTurbolanding
    | OpenEditTurbolandingsConstructorMetrikaAction;
